<template>
    <b-card header="Profile"
        header-bg-variant="info"
        header-text-variant="white"
        >
        <form @submit.prevent="saveProfile()" @keydown="form.clearError($event.target.name)">
            <b-row>
                <b-col lg="6">
                    <b-form-group label="First Name" label-for="firstname">
                        <b-form-input
                            id="firstname"
                            name="firstname"
                            type="text"
                            v-model="form.firstname"
                            required
                            readonly
                        >
                        </b-form-input>
                        <input-help :form="form" field="firstname" text="Enter your first name."></input-help>
                    </b-form-group>
                    <b-form-group label="Last Name" label-for="lastname">
                        <b-form-input
                            id="lastname"
                            name="lastname"
                            type="text"
                            v-model="form.lastname"
                            required
                            readonly
                            >
                        </b-form-input>
                        <input-help :form="form" field="lastname" text="Enter your last name."></input-help>
                    </b-form-group>

                </b-col>
              <b-col lg="6">
                <b-form-group label="Date of Birth" label-for="dob">
                  <date-picker v-model="form.dob" placeholder="Date (MM/DD/YYYY)" readonly></date-picker>
                  <input-help :form="form" field="dob" text=""></input-help>
                </b-form-group>
              </b-col>
            </b-row>
            <template v-if="user.role_type === 'client'">
                <b-row>
                    <b-col>
                        <p class="h6">Power of Attorney</p>
                        <hr>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6">
                        <b-form-group label="First Name">
                            <b-form-input id="poa_first_name"
                                v-model="form.poa_first_name"
                                readonly></b-form-input>
                        </b-form-group>
                        <b-form-group label="Phone">
                            <b-form-input id="poa_phone"
                                v-model="form.poa_phone"
                                readonly></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6">
                        <b-form-group label="Last Name">
                            <b-form-input id="poa_last_name"
                                v-model="form.poa_last_name"
                                readonly></b-form-input>
                        </b-form-group>
                        <b-form-group label="Relationship">
                            <b-form-input id="poa_relationship"
                                v-model="form.poa_relationship"
                                readonly></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6" v-show="isUnum">
                        <b-form-group label="Payment Date">
                            <b-form-input id="payment_date"
                                v-model="form.payment_date"
                                readonly></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <b-row>
                <b-col lg="12" class="text-center">
                    <h3>Please call {{ supportNumber }} if you would like to edit your information.</h3>
                </b-col>
            </b-row>
        </form>
    </b-card>
</template>

<script>
    import FormatsDates from '../mixins/FormatsDates';
    import moment from "moment/moment";

    export default {
        props: {
            'client': {},
            'user': {},
            'supportNumber': String,
        },

        mixins: [FormatsDates],

        data() {
            return {
                form: new Form({
                    firstname: this.user.firstname,
                    lastname: this.user.lastname,
                    dob: this.user.date_of_birth ?  moment(this.user.date_of_birth).format( 'MM/DD/YYYY' ): null,
                    email: this.user.email,
                    poa_first_name: this.client.poa_first_name,
                    poa_last_name: this.client.poa_last_name,
                    poa_phone: this.client.poa_phone,
                    poa_relationship: this.client.poa_relationship,
                    payment_date: this.client.payment_date ? this.client.payment_date : null,
                })
            }
        },
      computed: {
        isUnum() {
          if (!this.client.carrier.name) {
            return false;
          }
          const name = this.client.carrier.name.toLowerCase();
          const needle = 'unum';
          return name.includes(needle);
        },
      },

        methods: {
            saveProfile() {
                this.form.post('/profile');
            },
          submit() {
            this.form.submit('patch', '/profile/dob');
          },
        }
    }
</script>
